import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '../context/LanguageContext';

const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  image = 'https://customer-assets.emergentagent.com/job_2c966088-8797-43ff-a34e-a4775ed9024e/artifacts/uf2kgi4a_favicon.jpg'
}) => {
  const { language } = useLanguage();
  
  const siteName = 'Datasignz CreativeMinds';
  const baseUrl = 'https://datasignz.nl';
  
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} | Video Production, Post-Production & Digital Services`;
  const fullCanonical = canonical ? `${baseUrl}${canonical}` : baseUrl;
  
  const langCode = {
    en: 'en_US',
    nl: 'nl_NL',
    es: 'es_ES',
    fr: 'fr_FR'
  }[language] || 'en_US';

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <html lang={language} />
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullCanonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={langCode} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
